import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'

/** Avancement d'un suivi : terminé, en cours ou pas commencé (modale des sessions, fiche apprenant #242). */
export function CompletionBadge({ status }: { status?: string | null }) {
  const { t } = useTranslation()
  switch (status) {
    case 'COMPLETED':
      return <Badge variant="success">{t('status.completed')}</Badge>
    case 'INCOMPLETE':
      return <Badge variant="warning">{t('home.inProgress')}</Badge>
    default:
      return <Badge variant="secondary">{t('status.not_attempted')}</Badge>
  }
}
